import { render, staticRenderFns } from "./EmptyMail.vue?vue&type=template&id=154ba58e"
import script from "./EmptyMail.vue?vue&type=script&lang=js"
export * from "./EmptyMail.vue?vue&type=script&lang=js"
import style0 from "./EmptyMail.vue?vue&type=style&index=0&id=154ba58e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports